'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_utils_Tauri$OsType() {
}
export { $c_Lapp_utils_Tauri$OsType as $c_Lapp_utils_Tauri$OsType };
$c_Lapp_utils_Tauri$OsType.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_utils_Tauri$OsType.prototype.constructor = $c_Lapp_utils_Tauri$OsType;
/** @constructor */
function $h_Lapp_utils_Tauri$OsType() {
}
export { $h_Lapp_utils_Tauri$OsType as $h_Lapp_utils_Tauri$OsType };
$h_Lapp_utils_Tauri$OsType.prototype = $c_Lapp_utils_Tauri$OsType.prototype;
$c_Lapp_utils_Tauri$OsType.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.utils.-Tauri$-Os-Type.js.map
